import React, { useContext } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/dropdown.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/transition.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/menu.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/form.css'
import { modelEnum, Model } from './Models'
import './styles.scss'
import Dropdown from './dropdownContainer'
import { integerCurrencyFormatter } from 'lib/formatters'
import { LocaleContext } from 'contexts/locale'

export interface SelectorProps {
  currentModel: modelEnum
  currentIncome: number
  currentYear: number
  availableIncomeBrackets: number[]
  modelChangeHandler: (model: modelEnum) => void
  incomeChangeHandler: (income: number) => void
  yearChangeHandler: (year: number) => void
}

const models = [
  Model.SINGLE,
  Model.RETIRED,
  Model.MARRIED_WITHOUT_CHILDREN,
  Model.MARRIED_WITH_CHILDREN,
  Model.MARRIED_WITH_CHILDREN_AND_DUAL_INCOME
]

export default function Selector({
  currentModel,
  modelChangeHandler,
  currentIncome,
  incomeChangeHandler,
  currentYear,
  yearChangeHandler,
  availableIncomeBrackets
}: SelectorProps) {
  const locale = useContext(LocaleContext)
  const messages = require('./locales/' + locale + '.yml')

  return (
    <div className='selector ui form'>
      <div className='stackable two fields'>
        <div className='field'>
          <label>{messages['selectModelLabel']}</label>
          <Dropdown
            currentValue={currentModel}
            currentText={messages[currentModel]}
            changeHandler={modelChangeHandler}
            options={models.map(model => ({
              text: messages[model],
              value: model
            }))}
          />
        </div>
        <div className='field'>
          <label>{messages['selectIncomeLabel']}</label>
          <Dropdown
            currentText={integerCurrencyFormatter(locale)(currentIncome)}
            currentValue={currentIncome}
            options={availableIncomeBrackets.map(bracket => ({
              text: integerCurrencyFormatter(locale)(bracket),
              value: bracket
            }))}
            changeHandler={incomeChangeHandler}
          />
        </div>
      </div>
    </div>
  )
}
